import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
import Video from "../components/video.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Ninja Gaiden is a nightmare game when I was kid... `}<a parentName="p" {...{
        "href": "#tldr"
      }}>{`TL;DR`}</a></p>
    <h1>{`Ninja Gaiden`}</h1>
    <p>{`This is the ninja game for real ninja. Jump & slash, swift moving and never hesitate. I cannot beat this game as a kid and still struggle today. But now `}<a parentName="p" {...{
        "href": "https://deepmind.com/research/dqn/"
      }}>{`dqn`}</a>{` sounds so powerful that we probably got some chances?`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "191px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8168a3a2e6ed9d81819baa6c02d8cb40/0824c/ninja-gaiden.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "139.33333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAcABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDAgT/xAAYAQEAAwEAAAAAAAAAAAAAAAABAAIDBP/aAAwDAQACEAMQAAABosS596jG2ZdFURIj/8QAGxAAAgMBAQEAAAAAAAAAAAAAAQIAAxESEEH/2gAIAQEAAQUCWuBQy8iMTK2Xx94ryBDn3BBP/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEhAhL/2gAIAQMBAT8BbpB5pyf/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQMf/aAAgBAgEBPwGMouZ//8QAGRAAAwEBAQAAAAAAAAAAAAAAAAExEBEh/9oACAEBAAY/AjqzyHMaJCi3/8QAHRABAAMAAgMBAAAAAAAAAAAAAQARITFhQVFxkf/aAAgBAQABPyE3oJoDPc+v7BFcpbOAVe5gF2vmi52xJgUhHrzB0rDbtuFV1NHLP//aAAwDAQACAAMAAAAQ7M7A/8QAGxEAAgIDAQAAAAAAAAAAAAAAABEBMSFBYaH/2gAIAQMBAT8Q0qI7LzHjD8P/xAAXEQEBAQEAAAAAAAAAAAAAAAABABGB/9oACAECAQE/EBhdtWjFy//EAB4QAQEAAgICAwAAAAAAAAAAAAERADEhUWFxQZGh/9oACAEBAAE/EObqTluX2NQcTzMDOeWBlxNH5s3lRVFsdawlOWpeXvCDGkA77wjuCbLf5MBQ/eHf8lvrAIQjsxIrR85//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ninja Gaiden, from Tecmo",
            "title": "Ninja Gaiden, from Tecmo",
            "src": "/static/8168a3a2e6ed9d81819baa6c02d8cb40/0824c/ninja-gaiden.jpg",
            "srcSet": ["/static/8168a3a2e6ed9d81819baa6c02d8cb40/75985/ninja-gaiden.jpg 150w", "/static/8168a3a2e6ed9d81819baa6c02d8cb40/0824c/ninja-gaiden.jpg 191w"],
            "sizes": "(max-width: 191px) 100vw, 191px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Ninja Gaiden, from Tecmo`}</figcaption>{`
  `}</figure>
    <h1>{`Wait...`}</h1>
    <p>{`There Are Already a Lot of Nice Stuff for these type of games e.g. Super Mario Bros. It looks this problem is solved (AI beats human). However they are not ninja gaiden ☺︎ . This game is quite special and different from game like super mario. It's unfriendly to beginner; it has complicate scenes (visually, e.g. strange climb detection and bounding box); it has a few glitches/techniques (multiple slashes, air floor, and damage boost) that makes interesting for AI to explore; a lot of different powerup weapons and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ninpo`}</code>{`; ... Most importantly, having finished readings on this great `}<a parentName="p" {...{
        "href": "https://simoninithomas.github.io/Deep_reinforcement_learning_Course/"
      }}>{`intro`}</a>{` website (recommend for beginner of reinforcement learning), it makes me very curious to see whether career of Ryu/ninja can be replaced by state of art reinforcement learning agent.`}</p>
    <h1>{`OpenAI Gym`}</h1>
    <p><a parentName="p" {...{
        "href": "https://gym.openai.com/"
      }}>{`Gym`}</a>{` is the environment created to train AI on many different games. NES game's Gym is not officially supported due to some reasons. The quick search leads me to the work like `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=qv6UVOQ0F44"
      }}>{`Mario NEAT`}</a>{` below that uses the Lua script on `}<a parentName="p" {...{
        "href": "http://www.fceux.com/web/home.html"
      }}>{`Fceux`}</a>{`. Not a fan of Lua, so I started to look for something in Python. `}</p>
    <Video videoSrcURL="https://www.youtube.com/embed/qv6UVOQ0F44" videoTitle="NEAT Mario" style={{
      margin: "0 auto"
    }} mdxType="Video" />
    <p>{`Finally, I end up with `}<a parentName="p" {...{
        "href": "https://github.com/Kautenja/nes-py"
      }}>{`nes-py`}</a>{`, which is very pythony and have `}<a parentName="p" {...{
        "href": "https://github.com/Kautenja/nes-py/wiki/Creating-Environments"
      }}>{`wiki`}</a>{` to help build your own environment. Even though I ran into some trouble building the nes-py package because python setuptools requires some strange CXXFLAGS (-flto-partition=None) that my clang doesn't like, but eventually I manually built this package with some hacky way in pip temp folders and moved around the *.so in nes-py package. BTW, the author of nes-py also have an example of Super Mario Bro's nes environment, check `}<a parentName="p" {...{
        "href": "https://github.com/Kautenja/nes-py/wiki/Creating-Environments"
      }}>{`it`}</a>{` out if interested.`}</p>
    <h1>{`Hack into Ninja Gaiden`}</h1>
    <p>{`Now we need to know where (memory address) is the data (e.g. hit point). Thanks to gamers, we have a nice website named `}<a parentName="p" {...{
        "href": "http://tasvideos.org/GameResources/NES/NinjaGaiden.html"
      }}>{`TASVideo`}</a>{` documenting a lot. But be aware some of them are not precise enough. For example, to get the x position of Ryu, I checked many the memory location and eventually figured it out it's a fixed point 3-bit float instead of the 2-bit screen position as in document.`}</p>
    <h1>{`Agents`}</h1>
    <p>{`Now let's go down to business. I stolen a lot of code from internet `}<a parentName="p" {...{
        "href": "https://github.com/jcwleo/mario_rl"
      }}>{`here`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/ikostrikov/pytorch-a2c-ppo-acktr/tree/master/a2c_ppo_acktr"
      }}>{`there`}</a>{`. Again before diving, I'd suggest you read through this free intro `}<a parentName="p" {...{
        "href": "https://simoninithomas.github.io/Deep_reinforcement_learning_Course/"
      }}>{`course`}</a>{` to understand the basics of a2c, ppo etc.. I created a simple and cruel reward function to best encourage moving fast to end of the level. No reward to slash enemy or gain `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ninpo`}</code>{` etc. because I really wanted to see an AI speedrunner.`}</p>
    <p>{`Let's first only focus on level 1-1. `}</p>
    <img {...{
      "src": "/bafc463945e125b2586439739481d11d/ninja-struggles.gif",
      "alt": "Ninja Learning Gaiden"
    }}></img>
    <p>{`Here's my shallow findings after 8 hours training (sorry slow computer) for different models:`}</p>
    <ol>
      <li parentName="ol">{`PPO performs not as good as A2C`}</li>
      <li parentName="ol">{`A2C stopped maybe due to bugs`}</li>
      <li parentName="ol">{`A2C curiority works mostly and even finished the level 1`}</li>
    </ol>
    <p>{`As non-expert, for these models I cannot really judge good or bad, but only based on the implementation result. None of them surprise me as they did in Super Mario. They seems to be really confused even after training a while. Later probably I should try out the OpenAI's newly published a2c models. But even with these little experience, I still could get some `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`the state-of-art`}</code>{` feeling.`}</p>
    <h1>{`What's Promising`}</h1>
    <h2>{`Climb the Obstacle`}</h2>
    <p>{`Most Agents will stop at the wall, because it doesn't know how to get there. some can search some just cannot.
I'm amazed AI with curiosity can actually figure out the wall climb jump. For human, it's really hard to do that since this behavior (control) is not quite human anyway.`}</p>
    <img {...{
      "src": "/6695fa1541c6ebff6abe6efcc79f6716/ninja-climb.gif",
      "alt": "Ninja Can Climb"
    }}></img>
    <h2>{`Powerup Items`}</h2>
    <p>{`Also thumb up for the self-motivated behavior to slash the ninpo even though I didn't give it as reward. Maybe the agent is just do it for fun ☺︎ .`}</p>
    <img {...{
      "src": "/ff9119407d48768873a6bef5ceea839f/ninja-blindly-powerup.gif",
      "alt": "Ninja blindly loves powerup :)"
    }}></img>
    <h2>{`Finding Secrets/Bugs`}</h2>
    <p>{`AI even can jump on air floor which is usually done by speedrunners.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "254px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/acc9b97c89b7d06d3550f9e995d32af9/6a91e/ninja-air-floor.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "89.33333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD2UlEQVQ4y5WRa1PiBhSG4wURqF0UrHa3a+uOW12vRce1Otr1jlxFUXADFQhEwIgkMQRCQhQJNwUBuRhAVnfafmv/Sn9T004/9VvPnPPOM+/MucwcAPg/0dbW1i7EP/KvJVBvb69SqVQoFBKpdHBwUODh4WFlv7JTLOrtE2xFt0Qi6u6SSqX/nSeXv7CBYDaTjoTDW2sb+XwOOfUvr6x8WFqCNZYrkuQyKe2HDchoCfoQw+aOSa01bu5IxN1/N0tlsu/HJw175qnpHyaUr39a21haWRX8qYGhtD0BWi06o2FmZMw5soLPG4UkFkzYvFEmEgPbq+rDkZ7DNzLLdyL9u1c7apP+W5l1qAM2bPnsHvToWK/VaTQ6g3F3S729trGu1RvWNzf1RqPJZAJW1zX2sS8TPyq5hd7ThaHxuUXLO0VC1VUn/HQ8R9PRTCafSmVvbvLEBRGNMgJcXSXydyWGYYEjtVo3/EVgWk7PvkDeD2mWl7UjfadvO4oBiKSTZIigojQlFM0gCBIIBDguEw5TLHtJEATALr4kVHJSJQ+p5PCEPL78DTGnICdFlaCbpFNRikokMvE4x3FpoRPHCY7LxxPpTOY2EqEAJhSJx+IkHqGjVyhoolU9l4sv0bHOlN9FX2XPkAsYJlwuFEGiPu8p6PT8DsWjR2eg89zvQ4Dry0TKrk0dbZS55IXfD6u+LqxOYqPtaT/EXuesFtv+vu3gwGE2g2cBMpeu/GFjWDd5na5Wyi2gmMri4134CFAlMbcLXh/sCM0qyYmuStATiaX3TDoY9jmdJyB4eI5SpWzxT6qRTmZuc8VCoQzcZ/PkXF94WlKJEB7oRPeqI/K+n5wQFQPC2Tkb6PD5MBjG3NCp10vsqA2/oKmTY3hLrbdaHUApexualYcmxDWKgN1ew+tOamEgPCWuYl42WbZarA7HCQQhdrvD4wlCbtjh9v587IIgD4oyQPkmT833hackVYpwQyc7XwHkTA862o7trn40avZMRpfLA4Kuj0eHwvID8z7kgneNBqvF7PdhQDZ5Y3sjwt8CZRJ3Qr7thZk0chyDLKjHkfSZYxQbY1M4RuMEi5Kc/5zBw3EEZRGUuQhzQJSK7S7NBDdn6OA5RbOl+0rr82+Pz782H1sXAX+j0fj06Sl3V07SsRqDJ4NIkcLvIlgWO7tnQkCpVOPrzxX+uVzla9UGzz9WK3yt1qhU+EpV0LoAfOOzc28XHpWF5weEXxCz/eE5JaZSAs3H54faI//QbDafq9Vmo/HE862Hh5awUtB6vcXXn2q1ZrnazGYL5WK5dFcq5IsCFPKlvwBGIXhzz/zMygAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ninja Finds Air Floor",
            "title": "Ninja Finds Air Floor",
            "src": "/static/acc9b97c89b7d06d3550f9e995d32af9/6a91e/ninja-air-floor.png",
            "srcSet": ["/static/acc9b97c89b7d06d3550f9e995d32af9/8a4e8/ninja-air-floor.png 150w", "/static/acc9b97c89b7d06d3550f9e995d32af9/6a91e/ninja-air-floor.png 254w"],
            "sizes": "(max-width: 254px) 100vw, 254px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Ninja Finds Air Floor`}</figcaption>{`
  `}</figure>
    <h1>{`Challenges`}</h1>
    <h2>{`Fight Tyson`}</h2>
    <p>{`Tyson is annoying for AI and beginners too. Sometimes, AI is just like a scared cat in the tree. `}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "250px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5582f8fef6ddad27ab4cdf6e14325952/63868/ninja-tyson.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "91.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD50lEQVQ4y5VSbVMaVxRe08ZMTceIxlozOjKkjto2DrGYGGca0/iKIiKvLuICuwgIBhBkAWF5W15WLL6BCOwCap1oCGqSWtLWmc70S7/0Q/9SrzN+6rfeOXNmznOe5zxn7r0Q9D/PrZpbIGpqam7qxsZGDofD5XJbHzzgPOT09vay2Wwej8disdra2jo6Ojo7Oz+vr2/48n7t3c/+OwzwFnWLeYYWT8+MD4+GSXJ0dLSnp2doaMjhcPi8vhWng/9oIDui900gmlnFkkwleD58I25ubu7u6n4x/LK1rqGx9u7A4DNgCPCWlpaRkZFJPr/3MbfrXqu29QnCHkC/fWnm8qc4vGslimILC4hKhQinp2VyBYrpJBIphumUSlguV8hkchhWgtCgKBEJBeObg7zHP7RASHedtuceFItRkQiVSGzabDaCCFDxRCgU3dzcsdvtLpcnHkvEYusU9WMkEjt9/fby8k+FQCBn3wkPNPv6G6FgKObxeD2eNaPRCPTBUHTV6fL7A2az2fLK4lkL+IgAjrsIgjg5OT0tVyX8MWH7bTevyf6YBUVDYGo8Hk8ANu50RcPJSHQ9kUhaLFabzUEGNigqEYlSwWC4Uqmcv7sSjY2JO2q9T5rwPhZ0AXtMEiO8sIxqMJVa/37evypdgtUWVIMiqOGNyheR24RyndWyen52dnZxJZkYl7Fvr/U3rQLxicwZ9sS2dwt55jibLJQXCHIluLVT2KdPdh3bp0JD3Bre2KLp/PH7dz+XK9XZifFZ4Nx/3/UdC/rbmfFFSTIUJULkVpD6x8cQhJ8MR/3hGD7n/UsdADcaCJJg+Q8fLk/e/ALE/NYavK/B2lsPFZdD8/PqyckZkQienpo9sJCaee0EXygUKhQiaQl1Li++Gh2fUiiQj9XfypWP6hmBmfvF1ggn/rwdmtfowCMbDEtmk1O3aEAwo0ql1un0JpNDZ1xB9GbQxTC9zea++v2P1+WqUykuTX71Vs6rqgYhjRoTiYRKpRJBjFKpBEMNYvHs3Jxcq10SvPgenpkSSyQKuQzDTJXKRfn8V71o0tz1iX2g3fv0IeRwrMlkShz3xmJJt9vvcvlhGLFa8Xh0w68WrJqMShVq0C/H48l8Lv/TaRWX8r3ffIo/qrN/fQcym60+n7dUOigWS/v7OfCvPB43wxQZmnGYDRab0+12A7xQKAJxIplyamFiqi8geuabfgpFIuuZDJ1OZ1Op7Pb2HvBPp3OZTG5nJ0NRW2SYAq1MJp9K7adSub10Np0p7OUP95mj3UwRYphDmj4EOZcrFQpHDHOUzx+ADMpS6RggNH1TXrfog2sayNkCQ5f+BRAXoJWE5M+JAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ninja Fears Tyson",
            "title": "Ninja Fears Tyson",
            "src": "/static/5582f8fef6ddad27ab4cdf6e14325952/63868/ninja-tyson.png",
            "srcSet": ["/static/5582f8fef6ddad27ab4cdf6e14325952/8a4e8/ninja-tyson.png 150w", "/static/5582f8fef6ddad27ab4cdf6e14325952/63868/ninja-tyson.png 250w"],
            "sizes": "(max-width: 250px) 100vw, 250px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Ninja Fears Tyson`}</figcaption>{`
  `}</figure>
    <h2>{`Strategy Thinking`}</h2>
    <p>{`Probably Super Mario is no brainer game, player doesn't need to think about strategy too much: all rewards can be achieved in very short time period or strategy is very easy to discover. But in this Ninja Gaiden, strategically gain Ninpo and other weapons can largely improve performance. Unfortunately, I didn't see any hopes for all the models I tested.`}</p>
    <h1>{`Real Ninja vs AI`}</h1>
    <p>{`First of all, human are still fine. At this point, AI cannot beat human or even beginners with a few min training. A long way to go! Also depending on game's genre, the more strategic the more hard for AI because they only have visual clues. Not like us, we've been educated from different kinds of source (visual, sound, feel...) since born. But AI can do really well in visual game and not suprisingly better than human because they can try different ways again and again and operate much faster than human. `}</p>
    <p>{`Look at this `}<a parentName="p" {...{
        "href": "https://youtu.be/OGZWkqdwfEI?t=8"
      }}>{`speedrunner`}</a>{`, human's proud!`}</p>
    <Video videoSrcURL="https://www.youtube.com/embed/OGZWkqdwfEI" videoTitle="Speedrun Ninja Gaiden Best Record" style={{
      margin: "0 auto"
    }} mdxType="Video" />
    <div id="tldr"></div>
    <h2>{`A Few Rough Ideas So Far`}</h2>
    <ol>
      <li parentName="ol">{`AI probably could have seen better given better emulator environment. NES game has limitation to show multiple enemy in same screen nor does it have alpha blending. You'll see blinking sprite from time to time. This probably annoys AI a bit.`}</li>
      <li parentName="ol">{`Multitask or modularization (components) helps. For example a better visual detection to identify the enemy and a thinker network with more memory to think strategy.`}</li>
      <li parentName="ol">{`I feel curiosity is a key factor to avoid local optimal and we should keep trying a lot in limited time.`}</li>
      <li parentName="ol">{`Human teacher will definitely help boost the performance. This is perhaps why Go players like `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Lee_Sedol"
        }}>{`Lee Sedol`}</a>{` cannot win AI cause we give them the optimal searching path we human found through years of training experience and computer is faster to process number/arithm than us `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`atop of our experience`}</code>{`. It's not a fair game at all from this pov. But I really appreciate our Go players to help promote AI techniques. Same idea can apply if we have our speed runners to teach computer and then they can beat us by searching and improving the margins. `}</li>
      <li parentName="ol">{`Perhaps within our era, AI without a huge team behind is still primitive. `}</li>
      <li parentName="ol">{`Purely relying on visual clues is like we human only trust our vision hunch (muscle memory?). It won't make us stand out in more strategical competition like `}<a parentName="li" {...{
          "href": "http://www.dota2.com/"
        }}>{`DoTA`}</a>{`. In these games, human sometimes can sacrifice some short time low reward to gain something bigger, and this experience is learnt from other resources after we are born. `}</li>
    </ol>
    {/*- # Resources
     DISPLAY=:0.0 python run.py # Display is to solve the device none error
     https://pytorch.org/tutorials/intermediate/reinforcement_q_learning.html
     https://www.cs.ubc.ca/~gberseth/blog/category/project.html
     https://github.com/udacity/deep-reinforcement-learning/blob/master/dqn/exercise/dqn_agent.py
     -*/}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      